module.exports = __webpack_public_path__ + "static/media/logo-portal.af91e06c.png";